import { useSyncExternalStore } from 'react';

let currentTime = Date.now();
let timer: number | null = null;
const listeners = new Set<() => void>();

function subscribe(listener: () => void): () => void {
  currentTime = Date.now();
  listeners.add(listener);
  if (timer === null) {
    timer = window.setInterval(() => {
      currentTime = Date.now();
      listeners.forEach((notify) => notify());
    }, 1_000);
  }

  return () => {
    listeners.delete(listener);
    if (listeners.size === 0 && timer !== null) {
      window.clearInterval(timer);
      timer = null;
    }
  };
}

const getSnapshot = () => currentTime;

/** One clock drives every visible deal, without rerendering the product grid. */
export function useDealRemainingMs(endsAt: string, clockOffsetMs = 0): number {
  const now = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
  return Math.max(0, Date.parse(endsAt) - (now + clockOffsetMs));
}

export interface CountdownPart {
  value: string;
  suffix: 'd' | 'h' | 'm' | 's';
}

export function countdownParts(remainingMs: number): CountdownPart[] {
  const total = Math.max(0, Math.floor(remainingMs / 1_000));
  const days = Math.floor(total / 86_400);
  const hours = Math.floor((total % 86_400) / 3_600);
  const minutes = Math.floor((total % 3_600) / 60);
  const seconds = total % 60;

  return [
    ...(days > 0 ? [{ value: String(days), suffix: 'd' as const }] : []),
    { value: String(hours).padStart(2, '0'), suffix: 'h' },
    { value: String(minutes).padStart(2, '0'), suffix: 'm' },
    { value: String(seconds).padStart(2, '0'), suffix: 's' },
  ];
}
